import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  get_viewproof,
  proof_approve,
  proof_reject,
  proof_log_table,
  setRejectModalOpen,
  setRejectComment,
  add_proof_comments,
} from "../../store/job/jobSlice";

const mapStateToProps = (state) => {
  const {proof_data,proof_log_data,proofLoading,is_reject_modal_open,reject_comment} = state.job;
  return {
    proof_data : proof_data,
    proof_log_data : proof_log_data,
    proofLoading : proofLoading,
    is_reject_modal_open : is_reject_modal_open,
    reject_comment : reject_comment
  }
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      get_viewproof,
      proof_approve,
      proof_reject,
      proof_log_table,
      setRejectModalOpen,
      setRejectComment,
      add_proof_comments,
    },
    dispatch,
  );

const Store = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);

export default Store;